import { render, staticRenderFns } from "./TheCarousel.vue?vue&type=template&id=bdeff430&scoped=true"
import script from "./TheCarousel.vue?vue&type=script&lang=js"
export * from "./TheCarousel.vue?vue&type=script&lang=js"
import style0 from "./TheCarousel.vue?vue&type=style&index=0&id=bdeff430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeff430",
  null
  
)

export default component.exports